export default "__VITE_ASSET__PTikxlmq__"